import React from "react";

const CustomIcons = ({ icon, height = 24, color = "currentColor" }) => {
  switch (icon) {
    case "overview":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.68401 0.750977H3.88372C5.49816 0.750977 6.81773 2.07269 6.81773 3.71767V21.2832C6.81773 22.9281 5.49816 24.2499 3.88372 24.2499H3.68401C2.06957 24.2499 0.75 22.9281 0.75 21.2832V3.71767C0.75 2.92852 1.06052 2.1734 1.61158 1.61746C2.16245 1.06173 2.90782 0.750977 3.68401 0.750977Z"
            stroke={color}
            strokeWidth="1.5"
          />
          <rect
            x="10.75"
            y="0.75"
            width="12.5"
            height="9.5"
            rx="3.25"
            stroke={color}
            strokeWidth="1.5"
          />
          <rect
            x="10.75"
            y="14.75"
            width="12.5"
            height="9.5"
            rx="3.25"
            stroke={color}
            strokeWidth="1.5"
          />
        </svg>
      );
    case "marketing":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.0008 0.500009H18.1957C17.3997 0.498056 16.6359 0.814446 16.0753 1.37887L13.9529 3.49989H5.24952C3.59306 3.50184 2.25113 4.84358 2.24913 6.49976V10.5933C-0.878276 13.9067 -0.725006 19.1262 2.58903 22.2521C5.90396 25.378 11.1244 25.2247 14.2498 21.9113C14.787 21.341 15.2411 20.6975 15.5967 20.0003H20.9996C22.6561 19.9983 23.998 18.6566 24 17.0004V3.50094C23.999 1.84378 22.6572 0.502009 21.0008 0.500009ZM17.134 2.43938C17.4143 2.15717 17.7972 1.99897 18.1947 1.99995H20.9998C21.8281 2.00092 22.4991 2.67179 22.5 3.49989V3.90319C22.0449 3.63855 21.5263 3.49989 20.9998 3.49989H16.0744L17.134 2.43938ZM1.49823 16.2493C1.50214 12.814 4.08457 9.92732 7.49902 9.54159V16.2493C7.49902 16.4485 7.57813 16.6389 7.71877 16.7796L12.4606 21.5206C9.55101 23.8477 5.30546 23.377 2.9769 20.467C2.01878 19.2697 1.49726 17.7825 1.49823 16.2493ZM10.0599 16.9993H14.958C14.8173 18.2658 14.3192 19.466 13.5213 20.4601L10.0599 16.9993ZM8.99916 15.4993V9.54159C12.1313 9.89607 14.6034 12.3677 14.9579 15.4993H8.99916ZM22.5009 16.9993C22.5 17.8274 21.829 18.4982 21.0007 18.4992H16.1876C17.4319 14.1176 14.8886 9.55709 10.5061 8.31314C8.21089 7.66179 5.74674 8.0358 3.74848 9.33849V6.49986C3.74945 5.67177 4.42044 5.0009 5.24867 4.99992H21.0007C21.829 5.0009 22.5 5.67177 22.5009 6.49986V16.9993Z"
            fill={color}
          />
        </svg>
      );
    case "settings":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.9917 0.994665C12.7414 0.994665 12.521 1.05163 12.2287 1.12959C11.9348 1.20754 11.59 1.31248 11.2077 1.44441C10.4432 1.70526 9.52568 2.05758 8.61868 2.43235C7.71168 2.80714 6.8167 3.2074 6.09112 3.5642C5.72832 3.7426 5.40752 3.90901 5.14517 4.06193C4.88281 4.21485 4.68942 4.33028 4.51254 4.5072C4.33563 4.6841 4.2157 4.88049 4.06278 5.14282C3.90986 5.40517 3.74496 5.72598 3.56655 6.08878C3.21125 6.81436 2.81095 7.71088 2.43469 8.61937C2.0599 9.52637 1.70911 10.4423 1.44825 11.2084C1.31782 11.5907 1.21138 11.937 1.13492 12.2309C1.05696 12.5247 1 12.7451 1 12.9954C1 13.2458 1.05697 13.4662 1.13492 13.76C1.21288 14.0538 1.31932 14.4002 1.45125 14.7824C1.7136 15.5485 2.06591 16.466 2.44218 17.373C2.81847 18.28 3.21873 19.1765 3.57553 19.9036C3.75393 20.2664 3.92183 20.5887 4.07476 20.8511C4.22767 21.1149 4.3476 21.3098 4.52451 21.4867C4.70141 21.6636 4.89331 21.7805 5.15714 21.9335C5.41949 22.0864 5.7418 22.2528 6.10463 22.4312C6.83021 22.788 7.72673 23.1898 8.63369 23.566C9.54069 23.9423 10.4567 24.2946 11.2227 24.557C11.605 24.6874 11.9513 24.7938 12.2452 24.8718C12.539 24.9497 12.7594 25.0067 13.0098 25.0067C13.2601 25.0067 13.4805 24.9497 13.7728 24.8718C14.0667 24.7938 14.4115 24.6889 14.7953 24.557C15.5598 24.2961 16.4758 23.9438 17.3828 23.569C18.2898 23.1942 19.1848 22.794 19.9104 22.4372C20.2732 22.2588 20.594 22.0924 20.8563 21.9394C21.1187 21.7865 21.3151 21.6666 21.4905 21.4912C21.6674 21.3143 21.7843 21.1224 21.9372 20.8601C22.0901 20.5977 22.2565 20.2754 22.435 19.9126C22.7903 19.187 23.1905 18.2905 23.5653 17.3835C23.9401 16.4765 24.2909 15.5605 24.5518 14.7945C24.6822 14.4122 24.7886 14.0659 24.8651 13.772C24.943 13.4782 25 13.2578 25 13.0074C25 12.7571 24.943 12.5367 24.8651 12.2429C24.7871 11.949 24.6807 11.6027 24.5503 11.2204C24.2879 10.4544 23.9356 9.53688 23.5608 8.62989C23.1845 7.72289 22.7828 6.82641 22.426 6.09929C22.2476 5.7365 22.0812 5.41416 21.9282 5.1518C21.7753 4.88795 21.6584 4.69606 21.4815 4.51917C21.3046 4.34227 21.1082 4.22234 20.8459 4.06942C20.5835 3.9165 20.2627 3.7501 19.8999 3.57019C19.1743 3.21339 18.2778 2.8116 17.3708 2.43534C16.4639 2.05908 15.5479 1.70676 14.7818 1.44441C14.3995 1.31398 14.0532 1.20754 13.7609 1.12809C13.467 1.05013 13.2467 0.993164 12.9963 0.993164L12.9917 0.994665ZM12.9917 2.14602C13.0037 2.14602 13.2091 2.1775 13.4625 2.24496C13.7159 2.31242 14.0397 2.41137 14.407 2.5358C15.1385 2.78615 16.038 3.13097 16.927 3.49975C17.816 3.86854 18.6961 4.26283 19.3902 4.60462C19.738 4.77553 20.0393 4.93444 20.2656 5.06635C20.4935 5.19828 20.6554 5.32421 20.6629 5.3332C20.6719 5.3422 20.7979 5.50561 20.9298 5.73349C21.0617 5.96137 21.2176 6.2582 21.3885 6.60599C21.7288 7.3001 22.1246 8.18161 22.4934 9.07061C22.8622 9.95961 23.207 10.8606 23.4574 11.5922C23.5818 11.958 23.6837 12.2863 23.7512 12.5397C23.8187 12.793 23.8471 12.9954 23.8471 13.0074C23.8471 13.0194 23.8217 13.2233 23.7542 13.4782C23.6867 13.7315 23.5833 14.0569 23.4589 14.4226C23.21 15.1542 22.8667 16.0552 22.4979 16.9442C22.1306 17.8332 21.7363 18.7132 21.396 19.4073C21.2266 19.7551 21.0707 20.0535 20.9388 20.2798C20.8069 20.5062 20.6839 20.6726 20.6749 20.6816C20.6659 20.6906 20.501 20.8135 20.2731 20.9455C20.0468 21.0774 19.7454 21.2363 19.3976 21.4072C18.7035 21.7475 17.8235 22.1418 16.936 22.5091C16.0485 22.8764 15.1475 23.2197 14.4174 23.47C14.0516 23.5945 13.7308 23.6964 13.4775 23.7639C13.2241 23.8313 13.0157 23.8598 13.0037 23.8598C12.9917 23.8598 12.7908 23.8313 12.536 23.7639C12.2826 23.6964 11.9543 23.5945 11.5885 23.4685C10.8569 23.2182 9.9574 22.8734 9.0684 22.5046C8.17941 22.1358 7.29939 21.7415 6.60528 21.3997C6.25747 21.2288 5.96063 21.0729 5.73428 20.941C5.50641 20.8091 5.34451 20.6831 5.33549 20.6741C5.32649 20.6651 5.20056 20.5017 5.06864 20.2738C4.93671 20.046 4.7778 19.7461 4.60691 19.3984C4.2666 18.7042 3.87081 17.8227 3.50203 16.9337C3.13324 16.0447 2.78992 15.1437 2.53958 14.4122C2.41515 14.0464 2.3162 13.721 2.24874 13.4677C2.18128 13.2144 2.1498 13.009 2.1498 12.9969C2.1498 12.9849 2.18128 12.7796 2.24724 12.5262C2.31471 12.2728 2.41215 11.9475 2.53808 11.5817C2.78694 10.8502 3.13026 9.94916 3.49904 9.06016C3.86633 8.17116 4.26062 7.29115 4.60092 6.59704C4.77033 6.24923 4.93073 5.9479 5.06115 5.72155C5.19308 5.49368 5.31751 5.33327 5.328 5.32276C5.337 5.31376 5.49891 5.18783 5.7253 5.05591C5.95169 4.92398 6.25001 4.76807 6.59779 4.59717C7.2919 4.25686 8.17192 3.86257 9.05942 3.49529C9.94692 3.12801 10.8464 2.78467 11.578 2.53433C11.9438 2.4099 12.2706 2.30796 12.5255 2.2405C12.7789 2.17304 12.9797 2.14455 12.9917 2.14455L12.9917 2.14602ZM13.0007 8.59705C10.5751 8.59705 8.5949 10.5759 8.5949 13.0029C8.5949 15.4285 10.5753 17.4087 13.0007 17.4087C15.4264 17.4087 17.4054 15.4299 17.4054 13.004C17.4054 10.5784 15.4266 8.5982 13.0007 8.5982V8.59705ZM13.0007 9.7484C14.8042 9.7484 16.2524 11.1996 16.2524 13.0031C16.2524 14.8066 14.8043 16.2548 13.0007 16.2548C11.1973 16.2548 9.74457 14.8066 9.74457 13.0031C9.74457 11.1996 11.1957 9.7484 13.0007 9.7484Z"
            fill={color}
            stroke={color}
            strokeWidth="0.5"
          />
        </svg>
      );
    case "alert":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0001 0.751406C10.6618 0.751406 9.49804 1.6063 9.20671 2.78457H8.49574C5.5884 2.78457 3.22045 5.09335 3.22045 7.92651V18.8209H2.05666L2.05522 18.8195C1.90812 18.8195 1.7668 18.8757 1.66296 18.977C1.55769 19.0782 1.5 19.216 1.5 19.3594C1.5 19.5028 1.55769 19.6406 1.66296 19.7419C1.7668 19.8431 1.90812 19.8993 2.05522 19.8993H7.99098C8.29239 21.7961 9.97967 23.25 12 23.25C14.0203 23.25 15.7106 21.7961 16.0119 19.8993H21.9477C22.252 19.8993 22.5 19.6575 22.5 19.3594C22.5 19.0627 22.252 18.8209 21.9477 18.8195H20.7839V7.92511C20.7839 5.09187 18.4144 2.78316 15.5071 2.78316H14.7961C14.5034 1.60489 13.3382 0.75 11.9999 0.75L12.0001 0.751406ZM11.9986 1.83408C12.7514 1.83408 13.3686 2.23341 13.6268 2.78457H10.3705C10.6286 2.23341 11.2444 1.83408 11.9972 1.83408H11.9986ZM8.49426 3.86443H15.5058C17.8147 3.86443 19.6736 5.67828 19.6736 7.92795V18.8223L4.32505 18.8195V7.92514C4.32505 5.67543 6.18541 3.86306 8.49426 3.86162V3.86443ZM9.11294 19.9007H14.8844C14.6003 21.2042 13.4192 22.1687 11.9987 22.1687C10.5782 22.1687 9.39703 21.2028 9.11294 19.9007Z"
            fill={color}
            stroke={color}
            strokeWidth="0.5"
          />
        </svg>
      );
    case "support":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0.75C5.79045 0.75 0.75 5.79135 0.75 12C0.75 18.2095 5.79045 23.25 12 23.25C18.2087 23.25 23.25 18.2095 23.25 12C23.25 5.79135 18.2087 0.75 12 0.75ZM12 1.454C17.8288 1.454 22.5469 6.17203 22.5469 12.0009C22.5469 17.8297 17.8288 22.5478 12 22.5478C6.17115 22.5478 1.45312 17.8297 1.45312 12.0009C1.45312 6.17203 6.17115 1.454 12 1.454ZM12 5.5022C9.69375 5.5022 7.81725 7.37956 7.81725 9.68495C7.81813 9.87831 7.9737 10.0348 8.16706 10.0356C8.26022 10.0365 8.34987 9.9996 8.41579 9.93369C8.48259 9.86777 8.51951 9.77812 8.51951 9.68495C8.51951 7.75926 10.0734 6.20532 11.9991 6.20532C13.9249 6.20532 15.4797 7.75922 15.4797 9.68495C15.4797 11.0965 14.642 12.3066 13.4397 12.8534C12.5485 13.2595 11.6459 14.0478 11.6459 15.15V15.2161L11.6467 15.217C11.6467 15.3101 11.6845 15.3998 11.7504 15.4657C11.8164 15.5316 11.906 15.5685 12.0001 15.5677C12.1934 15.5677 12.3499 15.4103 12.3507 15.217V15.1509C12.3507 14.4486 12.9924 13.829 13.7306 13.4924C15.1773 12.8341 16.1836 11.3751 16.1836 9.68491C16.1836 7.37866 14.3063 5.5022 12 5.5022ZM11.9859 17.4502C11.7047 17.4572 11.4753 17.691 11.4753 17.974C11.4753 18.2614 11.7126 18.4978 12 18.4978C12.2874 18.4978 12.5238 18.2614 12.5238 17.974C12.5238 17.6866 12.2874 17.4502 12 17.4502H11.9859Z"
            fill={color}
            stroke={color}
          />
        </svg>
      );
    case "site_analytics":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.2764 6V7.511H19.3944L10.3619 16.453L6.92776 13.0532L2 17.9315L3.07929 19L6.92776 15.1901L10.3619 18.5898L20.4737 8.57947V11.6663H22V6H16.2764Z"
            fill={color}
          />
        </svg>
      );
    case "customer_performance":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 3C7.03 3 3 7.03 3 12H5C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12H21C21 7.03 16.97 3 12 3Z"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 12L16 8"
            stroke={color}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="12" cy="12" r="1.5" fill={color} />
        </svg>
      );
    case "product_performance":
      return (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Product box */}
          <rect x="3" y="7" width="7" height="7" rx="2" stroke={color} strokeWidth="1.5" fill="none" />
          {/* Bar chart */}
          <rect x="13" y="10" width="2" height="4" rx="1" fill={color} />
          <rect x="17" y="8" width="2" height="6" rx="1" fill={color} />
          <rect x="13" y="6" width="2" height="2" rx="1" fill={color} />
          {/* Product label lines */}
          <line x1="4.5" y1="15.5" x2="9.5" y2="15.5" stroke={color} strokeWidth="1" strokeLinecap="round" />
        </svg>
      );
    default:
      return null;
  }
};

export default CustomIcons;
